import {
  GET,
  GET_FULFILLED,
  GET_REJECTED,
} from "./actionTypes";

const initialState = {
  isLoading: false,
  summary: [],
  skillMatrix: null,
  suggestions: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET:
      return { ...state, isLoading: true };
    case GET_FULFILLED:
      return {
        ...state,
        isLoading: false,
        summary: action.payload.summary,
        skillMatrix: action.payload.skillMatrix, 
        suggestions: action.payload.suggestions,
      };
    case GET_REJECTED:
      return { ...state, isLoading: false };
    default:
      return state;
  }
}
